<div class="row mb-3">
  <div class="col-12">
    <label class="form-label" *ngIf="hasLabel" [for]="label">
      {{ label | translate }} ({{ timezoneName }})
    </label>
    <input
      type="date"
      class="form-control"
      [formControl]="dateOnlyValue"
      [required]="required && !disabled"
      [disabled]="disabled"
      [min]="min"
      [max]="max"
      [attr.id]="resolvedInputId"
    />
  </div>

  <!-- Hours -->
  <div class="col-4 mt-3">
    <label class="form-label" for="hours">
      {{ 'label.hours' | translate }}
    </label>
    <select
      class="form-select"
      [formControl]="hours"
      [disabled]="disabled"
      id="hours"
    >
      <option *ngFor="let option of hoursOptions" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>

  <!-- Minutes -->
  <div class="col-4 mt-3">
    <label class="form-label" for="minutes">
      {{ 'label.minutes' | translate }}
    </label>
    <select
      class="form-select"
      [formControl]="minutes"
      [disabled]="disabled"
      id="minutes"
    >
      <option *ngFor="let option of minutesOptions" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>

  <!-- Seconds -->
  <div class="col-4 mt-3">
    <label class="form-label" for="seconds">
      {{ 'label.seconds' | translate }}
    </label>
    <select
      class="form-select"
      [formControl]="seconds"
      [disabled]="disabled"
      id="seconds"
    >
      <option *ngFor="let option of secondsOptions" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</div>
